<div class="form-field">
    <div class="input-group mb-1">
        <ms-country-code-dropdown [selectedCountryCode]="countryCode"
            (countryCodeChange)="onCountryCodeChange($event)" />
        <input id="telephone-input" type="tel" [formControl]="phoneControl" (blur)="onBlur()" placeholder="Phone Number"
             mask="{{FormMask.TelPattern}}" class="form-control w-25" [class.is-valid]="isValid" [class.is-invalid]="hasErrors" />
        <input id="extension-input" type="tel" [value]="extension" (input)="onExtensionInput($event)" (blur)="onBlur()"
            mask="{{FormMask.TelExtPattern}}" placeholder="Ext" maxlength="10" class="form-control" />
    </div>
    @if(hasErrors && touched) {
    <div class="error-messages">
        @for(error of getErrors(); track $index) {
        <p class="text-danger text-start pt-1 mb-0">{{ error }}</p>
        }
    </div>
    }
</div>